export default "__VITE_ASSET__BlDOLN6d__"